export const BFF_BASE_URL = import.meta.env.VITE_BFF_BASE_URL;
export const BFF_BASE_ADMIN = `${BFF_BASE_URL}admin/`;

export const BASE_URL = import.meta.env.VITE_BASE_URL;
export const KAI_BASE_URL = import.meta.env.VITE_KAI_BASE_URL;
export const AI_BASE_URL = import.meta.env.VITE_AI_BASE_URL;
export const BASE_ADMIN = `${BASE_URL}backoffice/`;

export const AUTH_SIGN_IN_URL = `${BASE_URL}api/token/`;
export const AUTH_SIGN_IN_REFRESH_URL = `${BASE_URL}api/token/refresh/`;
export const WHO_AM_I_URL = `${BASE_URL}users/whoami/`;

export const QUOTATIONS_URL = `${BASE_ADMIN}quotations/`;
export const QUOTATION_CLASSIFICATION_URL = `${QUOTATIONS_URL}get_classification/`;
export const QUOTATION_SLAS_URL = `${QUOTATIONS_URL}get_slas/`;
export const QUOTATION_URL = (uuid: string) =>
  `${BASE_ADMIN}quotations/${uuid}/`;

export const QUOTATION_HISTORIES_URL = (uuid: string) =>
  `${BASE_ADMIN}quotations/${uuid}/history/`;

export const DUPLICATE_QUOTATION_REQUESTS_URL = (uuid: string) =>
  `${BASE_ADMIN}quotations/${uuid}/duplicate/`;
export const QUOTATION_REQUESTS_URL = `${BASE_ADMIN}quotations/requests/`;
export const QUOTATION_REQUESTS_CLASSIFICATION_URL = `${QUOTATION_REQUESTS_URL}get_classification/`;
export const QUOTATION_REQUESTS_SLAS_URL = `${QUOTATION_REQUESTS_URL}get-slas/`;
export const QUOTATION_REQUEST_URL = (uuid: string) =>
  `${BASE_ADMIN}quotations/requests/${uuid}/`;
export const QUOTATION_REQUEST_UPLOAD_URL = `${BASE_URL}base/files/quotation/upload/`;

export const QUOTATION_REQUEST_BULK_URL = `${BASE_ADMIN}quotations/requests/bulk_update/`;
export const QUOTATION_BULK_URL = `${BASE_ADMIN}quotations/bulk_update/`;
export const SALE_ORDER_BULK_URL = `${BASE_ADMIN}sale/orders/bulk_update/`;

export const PROFILES_URL = `${BASE_ADMIN}users/profile/`;
export const PROFILE_ADD_USER_URL = (uuid: string) =>
  `${BASE_ADMIN}users/profile/${uuid}/add_user/`;
export const PROFILE_UPDATE_USER_URL = (uuid: string) =>
  `${BASE_ADMIN}users/profile/${uuid}/update_user/`;
export const PROFILE_FILES_URL = `${BASE_URL}base/files/profile/upload/`;

export const PROFILES_MERGE_URL = `${BASE_ADMIN}users/profiles/merge/`;

export const USERS_URL = `${BASE_ADMIN}users/users/`;
export const USER_URL = (uuid: string) => `${BASE_ADMIN}users/users/${uuid}/`;

export const ADD_ADDRESS_URL = (profileUuid: string) =>
  `${BASE_ADMIN}users/profile/${profileUuid}/add_address/`;
export const ADDRESSES_URL = (profileUuid: string) =>
  `${BASE_ADMIN}users/profile/${profileUuid}/`;

export const FINANCE_PROFILE_URL = (uuid: string) =>
  `${BASE_ADMIN}users/profile/finance/${uuid}/`;

export const FINANCE_PROFILES_URL = `${BASE_ADMIN}users/profile/finance/`;

export const CATALOG_CATEGORIES_URL = `${BASE_URL}catalog/categories/`;
export const CATALOG_CATEGORY_URL = (uuid: string) =>
  `${BASE_ADMIN}catalog/categories/${uuid}/`;

export const CATALOG_PRODUCT_UPLOAD_URL = `${BASE_URL}base/files/catalog/upload/`;
export const CATALOG_PRODUCT_PUBLIC_UPLOAD_URL = (app: string) =>
  `${BASE_URL}base/public_files/${app}/upload/`;

export const CATALOG_PRODUCTS_URL = `${BASE_ADMIN}catalog/products/`;
export const CATALOG_PRODUCT_URL = (uuid: string) =>
  `${BASE_ADMIN}catalog/products/${uuid}/`;
export const CATALOG_PRODUCTS_MERGE_URL = `${BASE_ADMIN}catalog/products/merge/`;

export const CATALOG_PRODUCT_UPDATE_IMAGE_URL = (reference: string) =>
  `${BASE_ADMIN}catalog/products/${reference}/update_product_image/`;

export const BASE_FILE_SIGN_URL = `${BASE_URL}base/files/sign/`;

export const CATALOG_ATTRIBUTE_OPTION_URL = `${BASE_ADMIN}catalog/attribute-options/`;

export const ORDERS_URL = `${BASE_ADMIN}orders/`;
export const ORDER_URL = (uuid: string) => `${BASE_ADMIN}orders/${uuid}/`;
export const ORDER_PAYMENT_PROOF_URL = (id: string) =>
  `${BASE_URL}orders/payment_proof/${id}/`;
export const ORDER_INVOICE_PDF_URL = (id: string) =>
  `${BASE_URL}orders/invoice_pdf/${id}/`;
export const ORDER_INVOICE_XML_URL = (id: string) =>
  `${BASE_URL}orders/invoice_xml/${id}/`;

export const ACCOUNT_LEVEL_QUESTION_URL = `${BASE_URL}onboarding/questions/`;
export const ONBOARDING_FILES_URL = `${BASE_URL}base/upload_file/`;

export const SEARCH_ENGINE_URL = `${BASE_URL}base/search/`;

export const SUPPLIERS_URL = `${BASE_ADMIN}supplier/`;
export const SUPPLIER_URL = (uuid: string) => `${BASE_ADMIN}supplier/${uuid}/`;
export const MULTIPLES_SUPPLIER_PRODUCTS_URL = `${BASE_ADMIN}supplier/products/create-in-batch/`;
export const SUPPLIER_PRODUCTS_URL = `${BASE_URL}supplier/products/`;
export const SUPPLIER_PRODUCT_URL = (uuid: string) =>
  `${BASE_URL}supplier/products/${uuid}/`;
export const SUPPLIER_WAREHOUSES_URL = `${BASE_ADMIN}supplier/warehouse/`;
export const SUPPLIER_WAREHOUSE_URL = (uuid: string) =>
  `${BASE_ADMIN}supplier/warehouse/${uuid}/`;

export const SUPPLY_URL = `${BASE_ADMIN}supply/`;
export const SUPPLY_ORDERS_URL = `${SUPPLY_URL}orders/`;
export const SUPPLY_ORDER_URL = (uuid: string) =>
  `${SUPPLY_URL}orders/${uuid}/`;
export const GENERATE_PURCHASE_ORDER_URL = `${SUPPLY_URL}quotations/`;
export const GENERATE_PURCHASE_ORDER_PREVIEW_URL = `${SUPPLY_URL}quotations/preview/`;
export const GENERATE_PURCHASE_ORDER_PDF_PREVIEW_URL = `${SUPPLY_URL}quotations/file-preview/`;

export const SUPPLY_TRANSACTIONS_URL = `${BASE_ADMIN}finance/supply/transactions/`;
export const SUPPLY_TRANSACTION_URL = (uuid: string) =>
  `${BASE_ADMIN}finance/supply/transactions/${uuid}/`;
export const SUPPLY_ORDER_INVOICE_URL = (uuid: string) =>
  `${BASE_ADMIN}finance/supply/invoices/${uuid}/`;
export const SUPPLY_ORDER_PAYMENT_URL = (uuid: string) =>
  `${BASE_ADMIN}finance/supply/payments/${uuid}/`;

export const TRANSPORT_COMPANY_URL = `${BASE_ADMIN}logistic/transport-companies/`;
export const TRANSPORT_COMPANY_ROUTES_URL = `${BASE_ADMIN}logistic/transport-company-routes/`;
export const LOGISTIC_ROUTES_URL = `${BASE_ADMIN}logistic/routes/`;
export const LOGISTIC_VEHICLES_URL = `${BASE_ADMIN}logistic/vehicles/`;
export const LOGISTIC_ROUTE_ORIGINS_URL = `${BASE_ADMIN}logistic/routes/origins/`;

export const ORDER_TRACKER_URL = `${BASE_ADMIN}analytics/orders/`;
export const ORDER_TRACKER_REGENERATE_URL = `${BASE_ADMIN}analytics/orders/generate_data/`;

export const KAI_PRODUCTS_URL = `${KAI_BASE_URL}utils/product/`;
export const KAI_PRODUCT_URL = (uuid: string) =>
  `${KAI_BASE_URL}utils/product/${uuid}/`;
export const KAI_SMART_SEARCHS_URL = `${KAI_BASE_URL}searchengine/`;
export const KAI_SMART_SEARCH_URL = (uuid: string) =>
  `${KAI_BASE_URL}searchengine/${uuid}/`;

export const KAI_PRODUCTS_BY_REFERENCE_URL = `${KAI_BASE_URL}utils/product/enrichment-processor/queue/`;
export const KAI_PRODUCTS_BY_TEXT_URL = `${KAI_BASE_URL}utils/product/raw-information-processor/queue/`;
export const KAI_PRODUCTS_BY_FILE_URL = `${KAI_BASE_URL}utils/product/file-processor/queue/`;

export const DOLLAR_EXCHANGE_RATE_URL = `${BASE_URL}base/dollar-exchange-rate/`;
export const DOLLAR_QUOTATION_URL = `${BASE_URL}base/dollar-exchange-rate/latest/`;

export const ORDERS_CENTER_PROFILE_URL = `${BASE_ADMIN}sale/buyers/`;
export const ORDERS_CENTER_FINANCE_URL = `${BASE_ADMIN}sale/finances/`;
export const ORDERS_CENTER_CREDIT_URL = `${BASE_ADMIN}sale/credits/`;
export const ORDERS_CENTER_FINANCE_CLASSIFICATION_URL = `${BASE_ADMIN}finance/get_classification/`;
export const ORDERS_CENTER_LOGISTIC_URL = `${BASE_ADMIN}sale/logistics/`;
export const ORDERS_CENTER_LOGISTIC_GENERATE_DELIVERY_NOTE_URL = (
  uuid: string
) => `${ORDERS_CENTER_LOGISTIC_URL}${uuid}/generate-delivery-note/`;
export const ORDERS_CENTER_LOGISTIC_CLASSIFICATION_URL = `${BASE_ADMIN}logistic/shipments/get_classification/`;
export const ORDERS_CENTER_CREDIT_CLASSIFICATION_URL = `${BASE_ADMIN}credit/orders/get_classification/`;
export const ORDERS_CENTER_SALE_ORDERS_URL = `${BASE_ADMIN}sale/orders/`;
export const ORDERS_CENTER_SALE_ORDER_URL = (uuid: string) =>
  `${BASE_ADMIN}sale/orders/${uuid}/`;

export const ORDERS_CENTER_ORDER_CENTER_HISTORIES_URL = (uuid: string) =>
  `${BASE_ADMIN}sale/orders/${uuid}/history/`;

export const ORDERS_CENTER_COMMENTS_URL = (uuid: string) =>
  `${BASE_ADMIN}sale/orders/${uuid}/comments/`;

export const ORDERS_CENTER_INVOICE_URL = (uuid: string) =>
  `${BASE_ADMIN}finance/invoices/${uuid}/`;
export const ORDERS_CENTER_PAYMENT_URL = (uuid: string) =>
  `${BASE_ADMIN}finance/payments/${uuid}/`;
export const ORDER_CENTER_SHIPMENT_URL = (uuid: string) =>
  `${BASE_ADMIN}logistic/shipments/${uuid}/`;

export const CREDIT_ORDERS_URL = `${BASE_ADMIN}credit/orders/`;
export const CREDIT_ORDER_URL = (uuid: string) =>
  `${BASE_ADMIN}credit/orders/${uuid}/`;

export const TRANSACTIONS_URL = `${BASE_ADMIN}finance/transactions/`;
export const TRANSACTION_URL = (uuid: string) =>
  `${BASE_ADMIN}finance/transactions/${uuid}/`;

export const SALE_BOARD_METRICS_URL = `${BASE_ADMIN}analytics/sale_board/metrics/`;
export const SALE_BOARD_NOTICATIONS_URL = `${BASE_URL}base/notifications/`;
export const SALE_BOARD_NOTIFICATION_URL = (uuid: string) =>
  `${BASE_URL}base/notifications/${uuid}/`;
export const SALE_BOARD_BEST_SELLERS_URL = `${BASE_ADMIN}analytics/best-seller-products/`;

export const WORDPRESS_BASE_URL = `https://blog.mercai.ai/`;
export const WORDPRESS_POSTS_URL = `${WORDPRESS_BASE_URL}wp-json/wp/v2/posts?per_page=1&orderby=date&order=desc`;
export const CALCULATE_MARGIN_URL = `${BASE_URL}base/calculate-margin/`;
export const CALCULATE_UNIT_PRICE_URL = `${BASE_URL}base/calculate-unit-price/`;
export const CALCULATE_LOGISTIC_COSTS_URL = `${BASE_URL}base/calculate-logistic-costs/`;
export const ADDRESS_URL = `${BASE_URL}base/address/`;

export const AI_AGENTS_URL = `${AI_BASE_URL}admin/agents/`;
export const AI_AGENT_URL = (uuid?: string) =>
  `${AI_BASE_URL}admin/agents/${uuid}`;

export const AI_CONVERSATIONS_URL = `${AI_BASE_URL}admin/conversations/`;
export const AI_CONVERSATION_URL = (uuid?: string) =>
  `${AI_BASE_URL}admin/conversations/${uuid}`;
export const AI_CONVERSATION_EMAIL_URL = (email?: string) =>
  `${AI_BASE_URL}admin/conversations/email/${email}`;
export const AI_CONVERSATIONS_EVALUATION_URL = (uuid?: string) =>
  `${AI_BASE_URL}admin/conversations/${uuid}/evaluate`;
export const AI_CONVERSATIONS_WITH_AGENT_URL = `${AI_BASE_URL}admin/conversations/init-conversation-with-agent/`;

export const AI_REACTIVATION_URL = `${AI_BASE_URL}admin/reactivation/`;
export const AI_REACTIVATION_META_TEMPLATE_LIST_URL = `${AI_BASE_URL}admin/reactivation/meta-templates/`;

export const AI_CONVERSATIONS_EVALUATION_ALL_URL = `${AI_BASE_URL}admin/conversations/all/evaluate`;
export const AI_ADMIN_MESSAGES_URL = `${AI_BASE_URL}admin/messages`;
export const AI_ADMIN_MESSAGE_URL = (conversationUuid?: string) =>
  `${AI_BASE_URL}admin/messages/${conversationUuid}`;
export const AI_WHATSAPP_MESSAGES_URL = `${AI_BASE_URL}admin/messages/whatsapp/`;
export const AI_CONVERSATIONS_FORCE_FINISHED_URL = (uuid?: string) =>
  `${AI_BASE_URL}admin/conversations/${uuid}/force-finished`;
export const AI_CONVERSATION_METRICS_URL = `${AI_BASE_URL}admin/conversations/metrics/`;

export const AI_TAGS_URL = `${AI_BASE_URL}admin/tags/`;
export const AI_TAG_URL = (uuid?: string) => `${AI_BASE_URL}admin/tags/${uuid}`;

export const AI_DASHBOARD_MONTHLY_METRICS_URL = `${AI_BASE_URL}admin/dashboard/monthly-metrics/`;

export const AI_HOST_CONVERSATIONS_URL = `${AI_BASE_URL}admin/host-conversations/`;
export const AI_HOST_CONVERSATION_URL = (uuid?: string) =>
  `${AI_BASE_URL}admin/host-conversations/${uuid}`;

export const LEADS_URL = `${BASE_ADMIN}users/leads/`;
export const LEAD_URL = (uuid: string) => `${BASE_ADMIN}users/leads/${uuid}/`;

// BFF URLs
export const BFF_SALE_ORDERS_SIMPLIFIED_URL = `${BFF_BASE_ADMIN}sale-order/simplified/`;
export const BFF_SALE_ORDERS_URL = `${BFF_BASE_ADMIN}sale-order/`;
export const BFF_SALE_ORDER_URL = (uuid: string) =>
  `${BFF_BASE_ADMIN}sale-order/${uuid}/`;
export const BFF_SALE_ORDER_SUPPLY_ORDERS_URL = (uuid: string) =>
  `${BFF_BASE_ADMIN}sale-order/${uuid}/supply-orders/`;
export const BFF_SALE_ORDER_SUPPLY_ORDERS_DELETE_URL = (
  uuid: string,
  supplyOrderUuid: string
) => `${BFF_BASE_ADMIN}sale-order/${uuid}/supply-orders/${supplyOrderUuid}/`;
export const BFF_SALE_ORDER_CANCELLATION_UPDATE_SUPPLY_ORDERS_URL = (
  uuid: string
) => `${BFF_BASE_ADMIN}sale-order/${uuid}/cancellation/update-supply-orders/`;

export const BFF_SUPPLY_ORDERS_URL = `${BFF_BASE_ADMIN}supply-order/`;
export const BFF_SUPPLY_ORDER_URL = (uuid: string) =>
  `${BFF_BASE_ADMIN}supply-order/${uuid}/`;

export const BFF_SUPPLY_PAYMENTS_URL = `${BFF_BASE_ADMIN}supply-payment/`;

export const BFF_SUPPLY_PAYMENT_URL = (uuid: string) =>
  `${BFF_BASE_ADMIN}supply-payment/${uuid}/`;

export const BFF_SUPPLY_ORDER_MANAGMENT_PURCHASE_ORDER_ITEMS_URL = (
  uuid: string
) => `${BFF_BASE_ADMIN}order-management/purchase-order/${uuid}/items/`;

export const BFF_SUPPLY_ORDER_MANAGMENT_PURCHASE_ORDER_COMMENTS_URL = (
  uuid: string
) => `${BFF_BASE_ADMIN}order-management/purchase-order/${uuid}/comments/`;

export const BFF_SUPPLY_ORDER_MANAGMENT_PURCHASE_ORDER_HISTORY_URL = (
  uuid: string
) => `${BFF_BASE_ADMIN}order-management/purchase-order/${uuid}/history/`;

export const BFF_SUPPLY_ORDER_MANAGMENT_URL = (uuid: string) =>
  `${BFF_BASE_ADMIN}supply-order-update-management/${uuid}/`;

export const BFF_GENERATE_PURCHASE_ORDER_URL = `${BFF_BASE_ADMIN}supply-order/quotation/`;

export const BFF_SUPPLY_PREVIEW_URL = `${BFF_BASE_ADMIN}supply-order/preview/`;
export const BFF_GENERATE_SUPPLY_PREVIEW_URL = `${BFF_BASE_ADMIN}supply-order/generate/preview/`;
export const BFF_GENERATE_SUPPLY_PDF_PREVIEW_URL = `${BFF_BASE_ADMIN}supply-order/generate/pdf-preview/`;
export const BFF_GENERATE_SUPPLY_ITEMS_PREVIEW_URL = `${BFF_BASE_ADMIN}supply-order/generate/items-preview/`;
export const BFF_SUPPLY_ORDER_PAYMENT_REQUIRED_URL = `${BFF_BASE_ADMIN}supply-payment-required/`;
export const SALE_ORDER_ITEM_URL = (uuid: string) =>
  `${BASE_ADMIN}sale/orders/items/${uuid}/`;

export const BFF_INVENTORIES_URL = `${BFF_BASE_ADMIN}supply-inventory/`;
export const BFF_INVENTORY_URL = (uuid: string) =>
  `${BFF_BASE_ADMIN}supply-inventory/${uuid}/`;

export const BFF_INVENTORY_TRANSACTIONS_URL = `${BFF_BASE_ADMIN}supply-inventory-transaction/`;
export const BFF_INVENTORY_TRANSACTION_URL = (uuid: string) =>
  `${BFF_BASE_ADMIN}supply-inventory-transaction/${uuid}/`;

export const BFF_SUPPLY_TRANSACTIONS_URL = `${BFF_BASE_ADMIN}supply-transaction/`;
export const BFF_SUPPLY_TRANSACTION_URL = (uuid: string) =>
  `${BFF_BASE_ADMIN}supply-transaction/${uuid}/`;

export const BFF_SUPPLIER_PRODUCTS_URL = `${BFF_BASE_ADMIN}supplier-product/`;
export const BFF_SUPPLIER_PRODUCT_URL = (uuid: string) =>
  `${BFF_BASE_ADMIN}supplier-product/${uuid}/`;

export const BFF_FORECASTS_AND_INVENTORIES_URL = `${BFF_BASE_ADMIN}supplier-product/forecasts-and-inventory-transactions/`;

export const BFF_SUPPLIER_PRODUCTS_METRICS_URL = `${BFF_BASE_ADMIN}supplier-product/metrics/`;

export const BFF_USERS_ADDRESSES_URL = `${BFF_BASE_ADMIN}users/address`;
export const BFF_USERS_ADDRESS_URL = (uuid: string) =>
  `${BFF_BASE_ADMIN}users/address/${uuid}/`;

export const BFF_FORECASTS_URL = `${BFF_BASE_ADMIN}supplier/supplier-forecasts/`;
export const BFF_FORECAST_URL = (uuid: string) =>
  `${BFF_BASE_ADMIN}supplier/supplier-forecasts/${uuid}/`;

export const BFF_SUPPLIER_FORECAST_WITH_SUPPLIER_PRODUCT_URL = `${BFF_BASE_ADMIN}supplier/supplier-forecast-with-supplier-product/`;

export const BFF_LOGISTIC_TRANSPORT_COMPANIES_URL = `${BFF_BASE_ADMIN}logistic/transport-companies/`;
export const BFF_LOGISTIC_TRANSPORT_COMPANY_URL = (uuid: string) =>
  `${BFF_BASE_ADMIN}logistic/transport-companies/${uuid}/`;
export const BFF_LOGISTIC_TRANSPORT_COMPANY_ROUTES_URL = `${BFF_BASE_ADMIN}logistic/transport-company-routes/`;
export const BFF_LOGISTIC_TRANSPORT_COMPANY_ROUTE_URL = (uuid: string) =>
  `${BFF_BASE_ADMIN}logistic/transport-company-routes/${uuid}/`;
export const BFF_LOGISTIC_VEHICLES_URL = `${BFF_BASE_ADMIN}logistic/vehicles/`;
export const BFF_LOGISTIC_VEHICLE_URL = (uuid: string) =>
  `${BFF_BASE_ADMIN}logistic/vehicles/${uuid}/`;
export const BFF_LOGISTIC_ROUTES_URL = `${BFF_BASE_ADMIN}logistic/routes/`;
export const BFF_LOGISTIC_ROUTE_URL = (uuid: string) =>
  `${BFF_BASE_ADMIN}logistic/routes/${uuid}/`;

export const BFF_SHIPMENT_INVOICES_URL = `${BFF_BASE_ADMIN}finance/shipments/invoices/`;
export const BFF_SHIPMENT_INVOICE_URL = (uuid: string) =>
  `${BFF_BASE_ADMIN}finance/shipments/invoices/${uuid}/`;

export const BFF_SHIPMENT_INVOICES_MANAGEMENT_URL = `${BFF_BASE_ADMIN}finance/shipment-invoice-management`;
export const BFF_SHIPMENT_INVOICE_MANAGEMENT_URL = (uuid: string) =>
  `${BFF_BASE_ADMIN}finance/shipment-invoice-management/${uuid}/`;

export const BFF_CALCULATE_LOGISTIC_CUSTOMS_COSTS_URL = `${BFF_BASE_ADMIN}base/calculate-customs-cost/`;
